import { useTranslation } from 'react-i18next';

import { FaIcon, NgButtonNavLink, NgPageHeader } from '@/ui';

export function IncidentNotFoundPage() {
  const { t } = useTranslation();
  const pageTitle = t('Incident_NotFound_PageTitle');

  return (
    <div className="content h-100 p-3">
      <NgPageHeader title={pageTitle} />

      <div className="d-flex h-100 flex-column align-items-center justify-content-center gap-3 text-center">
        <div
          className="w-100 bg-warning-subtle border border-1 border-warning-subtle border-dashed rounded-1 px-3 py-5 text-warning"
          role="alert"
        >
          <h1 className="h4 mb-2" tabIndex={-1}>
            <FaIcon icon="fal fa-warning" /> {pageTitle}
          </h1>
          <p className="mb-0">{t('Incident_NotFound_Message')}</p>
        </div>

        <NgButtonNavLink
          to="/incident-list"
          icon="fal fa-arrow-left"
          text={t('Incident_NotFound_BackToIncidentListButton')}
        />
      </div>
    </div>
  );
}
